import { render } from "./NewsSubMenu.vue?vue&type=template&id=4861893c&scoped=true"
import script from "./NewsSubMenu.vue?vue&type=script&lang=js"
export * from "./NewsSubMenu.vue?vue&type=script&lang=js"

import "./NewsSubMenu.vue?vue&type=style&index=0&id=4861893c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4861893c"]])

export default __exports__